import { ValueFieldsProps } from "@/pages/talent/goals/components/key-result-form.types.ts";
import { Input } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export function PercentageValueFields({ formHook, isCreating }: ValueFieldsProps) {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
  } = formHook;

  return (
    <>
      <Input
        {...register("start_value", {
          setValueAs: (value: string) => (value === "" ? null : Number(value)),
        })}
        type="number"
        min={0}
        max={100}
        label={t("goals:start_value")}
        required
        error={errors.start_value?.message as string | undefined}
      />
      {isCreating && (
        <Input
          {...register("current_value", {
            setValueAs: (value: string) => (value === "" ? null : Number(value)),
          })}
          type="number"
          min={0}
          max={100}
          label={t("goals:current_value")}
          error={errors.current_value?.message as string | undefined}
        />
      )}
      <Input
        {...register("target_value", {
          setValueAs: (value: string) => (value === "" ? null : Number(value)),
        })}
        type="number"
        min={0}
        max={100}
        label={t("goals:target_value")}
        required
        error={errors.target_value?.message as string | undefined}
      />
    </>
  );
}
